import axios from "axios";
import { displayNotify } from "../../../shared/services/Notifications/NotificationServices";
import { useNavigate } from "react-router";

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

class AuthService {
  async authFetch(form: any) {
    const res = await axios.post("login/", form);
    console.log("Login response:", res.data);

    if (form.username) {
      localStorage.setItem("username", form.username);
    }

    const csrfToken = getCookie("csrftoken");
    axios.defaults.headers.common["X-CSRFToken"] = csrfToken;

    return res;
  }

  async regFetch(form: any) {
    const res = await axios.post("registration/", form);
    console.log(res);

    if (res?.data && res.status == 201) {
      const { username, email, user_callsign } = res.data;
      if (username) localStorage.setItem("username", username);
      if (email) localStorage.setItem("email", email);
      if (user_callsign) localStorage.setItem("user_callsign", user_callsign);

      await this.authFetch({ username: form.username, password: form.password });

    }

    return res;
  }

  async quitFetch() {
    const res = await axios.get("logout/");
    return res;
  }
}

const authService = new AuthService();

export function redirectToLogin() {
  console.log(window.location.pathname)
  if (window.location.pathname !== '/login')
    window.location.href = '/login';
}

export function clearUserData() {
  localStorage.removeItem('username');
  localStorage.removeItem('email');
  localStorage.removeItem('user_callsign');
  localStorage.removeItem('callsign');
}

  const codeDescriptions: any = {
    ok: { status: "success", description: "Выход удался" },
    error: { status: "error", description: "Выход не удался" },
  };

export function initiateLogout() {

  let notifyContent = { title: "Киберштаб" };

  authService.quitFetch()
    .then(() => {
      clearUserData()
      redirectToLogin()
      displayNotify({ ...notifyContent, ...codeDescriptions["ok"] });
    })
    .catch(() => {
      displayNotify({ ...notifyContent, ...codeDescriptions["error"] });
    })

}

export default authService;